import * as auth from './auth';
import * as property from './property';
import * as rentValue from './rentValue';
import * as split from './split';
import * as rentAdvance from './rentAdvance';
import * as zipcode from './zipcode';

export default {
    ...auth,
    ...property,
    ...rentValue,
    ...split,
    ...zipcode,
    rentAdvance,
};
